import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { KieneUtils } from '../../../utils/KieneUtils';
import { Gruppe } from '../../gruppen/classes/gruppe';
import { GruppeStandort } from '../../gruppen/gruppe-standort-verwalten/gruppe-standort';
import { HttpParams } from '@angular/common/http';
import { FormControl, UntypedFormControl, Validators } from '@angular/forms';
import { Betriebsart, Produktionsabschnitt } from '../../stammdaten/vvvo/classes/betriebsart';
import { Subscription, forkJoin } from 'rxjs';
import { KieneAutocompleteComponent } from '../../kiene-autocomplete/kiene-autocomplete.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../lib/kiene-core.config';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { KieneBackendApiService } from '../../../services/backend-api/kiene-backend-api.service';
import { LocalStorageService } from '../../../services/local-storage/local-storage.service';
import { MessageService } from '../../../services/message-service/message.service';
import { GruppeStandortWechselnDialogResult } from './gruppe-standort-wechseln-dialog-result';
import { formatDate } from '@angular/common';

@Component({
    selector: 'kiene-gruppe-standort-wechseln-dialog',
    templateUrl: './gruppe-standort-wechseln-dialog.component.html',
    styleUrls: ['./gruppe-standort-wechseln-dialog.component.scss'],
})
export class GruppeStandortWechselnDialogComponent implements OnInit {
    private readonly gewichtPermissionId = 9161;
    private currentStandortGsId: number = null;
    selectedTiere: { gt_id: number; ohrmarke_notnull: string; gewichtCtrl: FormControl; currentGsId?: number }[] = [];
    gewichtModusCtrl = new FormControl<'all' | 'single'>('single');
    gewichtAlleSelektiertCtrl = new FormControl();

    gruppe: Gruppe;

    gruppeStandort: GruppeStandort;
    standortApiUrl = this.apiBaseUrl + 'gruppe/read_stall_kundenportal.php';
    params: HttpParams;

    standortSelected: string;
    standortAusListe = false;
    stall: any;
    datumVonCtrl = new UntypedFormControl(undefined, [Validators.required]);
    datumBisCtrl = new FormControl();
    minDatumVon: Date | null = null;
    sgsNummerCtrl = new FormControl();

    produktionsabschnittCtrl = new FormControl<Produktionsabschnitt>(undefined);
    produktionsabschnitte: Produktionsabschnitt[] = [];
    produktionsabschnittSub: Subscription;

    anzahlTiereAnDatum = 0;
    gesamtgewichtCtrl = new FormControl();
    durchschnittsgewichtCtrl = new FormControl();
    showGewicht = false;
    sgsNummerEinblenden = false;
    /** Meine + freigegebene Betriebe (kunde_id), fuer Standort-Gewichtsuebertrag. */
    gewichtErlaubteKundeIds = new Set<number>();

    @ViewChild('standortAutocomplete')
    standortAutocomplete: KieneAutocompleteComponent;

    constructor(
        public dialogRef: MatDialogRef<GruppeStandortWechselnDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        @Inject(MAT_DATE_LOCALE) private locale: string,
        private api: KieneBackendApiService,
        private localStorageService: LocalStorageService,
        private messageService: MessageService,
    ) {
        if (this.data?.gruppe) {
            this.gruppe = this.data.gruppe;
            console.log(this.gruppe);
        } else {
            this.messageService.alertMessage('Keine Gruppe übergeben!');
        }

        if (this.data?.showGewicht) {
            this.showGewicht = true;
        }
    }

    ngOnInit(): void {
        this.loadGewichtErlaubteBetriebe();
        this.initGewichtCtrls();
        this.initSelectedTiereGewichte();
        this.loadSelectedTiereCurrentStandorte();

        if (this.gruppe?.kaelbermast > 0 || !!this.gruppe?.sgs_nummer) {
            this.sgsNummerEinblenden = true;
        }

        if (this.data.gruppeStandort) {
            this.gruppeStandort = <GruppeStandort>this.data.gruppeStandort;
            this.currentStandortGsId = Number(this.gruppeStandort?.gs_id) > 0 ? Number(this.gruppeStandort?.gs_id) : null;
            this.standortSelected = this.gruppeStandort.stall;
            this.standortAusListe = true;
            const stall = { stall: this.gruppeStandort.stall };
            this.stall = stall;
            const pa = new Produktionsabschnitt();
            pa.produktionsabschnitt = this.gruppeStandort.produktionsabschnitt;
            pa.produktionsabschnitt_id = this.gruppeStandort.produktionsabschnitt_id;
            this.produktionsabschnittCtrl.setValue(pa);
            this.datumVonCtrl.setValue(this.gruppeStandort.datum_von);
            this.datumBisCtrl.setValue(this.gruppeStandort.datum_bis);
            this.anzahlTiereAnDatum = this.gruppeStandort.anzahl_tiere;
            this.durchschnittsgewichtCtrl.setValue(this.gruppeStandort.einstallgewicht);
            this.sgsNummerCtrl.setValue(this.gruppeStandort.sgs_nummer);
        }

        this.params = new HttpParams();
        const currentUserId = Number(this.localStorageService.getCurrentUser()?.benutzer_id);
        if (!isNaN(currentUserId) && currentUserId > 0) {
            this.params = this.params.set('benutzer_id', currentUserId.toString());
        }
        this.ladeProduktionsabschnitte();
        this.loadMinDatumVon();

        this.initDatumCtrl();

        if (
            this.selectedTiere?.length === 0 &&
            (!this.gruppeStandort?.einstallgewicht || !this.gruppeStandort?.anzahl_tiere)
        ) {
            this.ladeTiereAnDatum(this.datumVonCtrl.value);
        }
    }

    setStandort(event: any) {
        if (event === null || event === undefined) {
            return;
        }
        if (typeof event === 'string') {
            this.standortSelected = event;
            this.standortAusListe = false;
        } else if (typeof event === 'object') {
            this.standortSelected = event.stall;
            this.standortAusListe = true;
            if (event.sgs_nummer) {
                this.sgsNummerCtrl.setValue(event.sgs_nummer);
            }
        } else {
        }
    }

    close() {
        this.dialogRef.close(new GruppeStandortWechselnDialogResult());
    }

    alteGewichteUebernehmen(showFeedback: boolean = true): void {
        if (!this.selectedTiere?.length) {
            return;
        }
        let params = new HttpParams();
        params = params.set('gruppe_id', this.gruppe.gruppe_id);
        this.api.getAll(this.apiBaseUrl + 'gruppe/read_gt_alte_gewichte.php', params).subscribe({
            next: response => {
                const records = response?.records || [];
                const weightByGtId = new Map<number, number>();
                for (const rec of records) {
                    const gtId = Number(rec?.gt_id);
                    const w = Number(rec?.gewicht_alt);
                    if (gtId > 0 && !isNaN(w) && w > 0) {
                        weightByGtId.set(gtId, w);
                    }
                }

                let gesetztDirekt = 0;
                for (const tier of this.selectedTiere) {
                    const w = weightByGtId.get(tier.gt_id);
                    if (w && w > 0) {
                        tier.gewichtCtrl.setValue(w);
                        gesetztDirekt++;
                    }
                }
                this.gewichtModusCtrl.setValue('single');
                if (showFeedback && gesetztDirekt > 0) {
                    this.messageService.infoMessage(
                        `Alte Gewichte fuer ${gesetztDirekt} Tier(e) uebernommen.`,
                    );
                } else if (showFeedback) {
                    this.messageService.infoMessage('Keine alten Gewichte gefunden.');
                }
            },
            error: err => {
                this.messageService.errorMessage('Alte Gewichte konnten nicht geladen werden!', err);
            },
        });
    }

    save() {
        this.saveStandortWechsel();
    }

    private saveStandortWechsel(): void {
        this.ensureCurrentStandorteBeforeSwitch(() => this.saveStandortWechselInternal());
    }

    private saveStandortWechselInternal(): void {
        if (!this.isStandortInputValid()) {
            this.messageService.errorMessage('Bitte einen Standort auswählen oder eingeben.', null);
            return;
        }
        if (!this.isDatumVonValidForNewStandort()) {
            this.messageService.errorMessage('Fehler! [DB] Datum muss größer als der letzte Eintrag sein', null);
            return;
        }
        if (!this.gruppeStandort) {
            this.gruppeStandort = new GruppeStandort();
        }
        if (this.selectedTiere?.length > 0 && this.gewichtModusCtrl.value === 'all') {
            const allGewicht = this.toValidGewicht(this.gewichtAlleSelektiertCtrl.value);
            if (allGewicht !== null) {
                for (const tier of this.selectedTiere) {
                    tier.gewichtCtrl.setValue(allGewicht, { emitEvent: false });
                }
            }
        }
        this.gruppeStandort.gruppe_id = this.gruppe.gruppe_id;
        this.gruppeStandort.stall = this.standortSelected;
        this.gruppeStandort.datum_von = this.datumVonCtrl.value;
        this.gruppeStandort.datum_bis = this.datumBisCtrl.value;
        this.gruppeStandort.einstallgewicht = this.isExternerBetriebZiel() ? null : this.gesamtgewichtCtrl.value;
        this.gruppeStandort.anzahl_tiere = this.anzahlTiereAnDatum;
        if (this.selectedTiere?.length > 0 && !this.isExternerBetriebZiel()) {
            const selectedGewichte = this.selectedTiere.map(t => this.toValidGewicht(t.gewichtCtrl.value)).filter(v => v !== null);
            const gesamtGewicht = selectedGewichte.length
                ? Math.round(selectedGewichte.reduce((sum, val) => sum + Number(val), 0) * 100) / 100
                : null;
            this.gruppeStandort.einstallgewicht = gesamtGewicht;
            this.gruppeStandort.anzahl_tiere = this.selectedTiere.length;
        }
        this.gruppeStandort.produktionsabschnitt_id = this.produktionsabschnittCtrl.value?.produktionsabschnitt_id;
        this.gruppeStandort.sgs_nummer = this.sgsNummerCtrl.value;
        (this.gruppeStandort as GruppeStandort & { defer_dashboard_aktion?: boolean }).defer_dashboard_aktion =
            this.selectedTiere?.length > 0;
        console.log('Abspeichern mit:', this.gruppeStandort);
        this.api.post(this.apiBaseUrl + 'gruppe_standort/update.php', this.gruppeStandort, undefined).subscribe({
            next: response => {
                const gsId = Number(response?.gs_id || this.gruppeStandort?.gs_id);
                if (gsId > 0 && this.selectedTiere?.length > 0) {
                    this.filterStandortToSelectedTiere(gsId);
                    return;
                }
                if (gsId > 0 && this.saveSelectedTiereGewichte(gsId)) {
                    return;
                }
                this.closeWithSuccess();
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    private ensureCurrentStandorteBeforeSwitch(onDone: () => void): void {
        if (!this.selectedTiere?.length) {
            onDone();
            return;
        }
        const gtIds = this.selectedTiere.map(t => Number(t.gt_id)).filter(id => id > 0);
        if (!gtIds.length) {
            onDone();
            return;
        }
        this.api
            .post(this.apiBaseUrl + 'gruppe_standort/ensure_erster_standort_tiere.php', {
                gruppe_id: this.gruppe?.gruppe_id,
                gt_ids: gtIds,
            })
            .subscribe({
                next: () => this.loadCurrentStandorteForSelectedTiere(onDone),
                error: err => {
                    this.messageService.errorMessage(
                        'Standortwechsel abgebrochen: Verknuepfung zum initialen Standort konnte nicht erstellt werden!',
                        err,
                    );
                },
            });
    }

    private loadCurrentStandorteForSelectedTiere(onDone: () => void): void {
        const gtIds = this.selectedTiere.map(t => Number(t.gt_id)).filter(id => id > 0);
        if (!gtIds.length) {
            onDone();
            return;
        }
        const params = new HttpParams().set('gt_ids', gtIds.join(','));
        this.api.getAll(this.apiBaseUrl + 'gruppe/read_gt_letzter_standort.php', params).subscribe({
            next: response => {
                const records = response?.records || [];
                const gsByGtId = new Map<number, number>();
                for (const rec of records) {
                    const gtId = Number(rec?.gt_id);
                    const gsId = Number(rec?.gs_id);
                    if (gtId > 0 && gsId > 0) {
                        gsByGtId.set(gtId, gsId);
                    }
                }
                for (const tier of this.selectedTiere) {
                    const resolvedGsId = gsByGtId.get(Number(tier.gt_id));
                    tier.currentGsId = resolvedGsId > 0 ? resolvedGsId : undefined;
                }
                const unresolved = this.selectedTiere.filter(t => Number(t?.currentGsId) <= 0);
                if (unresolved.length > 0) {
                    this.messageService.errorMessage(
                        `Standortwechsel abgebrochen: aktueller Standort fuer ${unresolved.length} Tier(e) nicht gefunden.`,
                        null,
                    );
                    return;
                }
                onDone();
            },
            error: err => {
                this.messageService.errorMessage(
                    'Standortwechsel abgebrochen: aktueller Standort der Tiere konnte nicht geladen werden!',
                    err,
                );
            },
        });
    }

    private filterStandortToSelectedTiere(gsId: number): void {
        const gtIds = this.selectedTiere.map(t => Number(t.gt_id)).filter(id => id > 0);
        this.api
            .post(this.apiBaseUrl + 'gruppe_standort/filter_selected_tiere.php', {
                gs_id: gsId,
                gruppe_id: this.gruppe?.gruppe_id,
                gt_ids: gtIds,
            })
            .subscribe({
                next: response => {
                    const selectedCount = gtIds.length;
                    const actualCount = Number(response?.count_actual);
                    if (!isNaN(actualCount) && actualCount > 0 && actualCount < selectedCount) {
                        this.messageService.errorMessage(
                            `Standortwechsel unvollstaendig: ${actualCount} von ${selectedCount} Tier(en) im neuen Standort.`,
                            null,
                        );
                        return;
                    }
                    if (this.saveSelectedTiereGewichte(gsId)) {
                        return;
                    }
                    this.closeWithSuccess();
                },
                error: err => {
                    this.messageService.errorMessage(
                        'Standort wurde erstellt, aber Tierauswahl konnte nicht korrekt gefiltert werden!',
                        err,
                    );
                },
            });
    }

    produktionsabschnittComparator(a: Produktionsabschnitt, b: Produktionsabschnitt): boolean {
        return KieneUtils.sameId(a?.produktionsabschnitt_id, b?.produktionsabschnitt_id);
    }

    ladeProduktionsabschnitte() {
        if (this.gruppe?.kunde_id) {
            this.produktionsabschnittSub?.unsubscribe();
            this.produktionsabschnittSub = this.api
                .getByIdAlternative(
                    this.apiBaseUrl + 'betriebsart/read_one_by_kunde.php',
                    'kunde_id',
                    this.gruppe?.kunde_id?.toString(),
                )
                .subscribe({
                    next: (betriebsart: Betriebsart) => {
                        this.produktionsabschnitte = betriebsart.produktionsabschnitte;
                        if (this.produktionsabschnitte?.length === 1) {
                            this.produktionsabschnittCtrl.setValue(this.produktionsabschnitte[0]);
                        }
                    },
                    error: err => {
                        this.messageService.errorMessage('Produktionsabschnitte konnten nicht geladen werden!', err);
                    },
                });
        }
    }

    deleteStall(gruppe: Gruppe) {
        this.api.deleteGeneric(this.apiBaseUrl + 'gruppe/delete_stall.php', gruppe).subscribe({
            next: () => {
                this.messageService.infoMessage('Der Standort wurde erfolgreich gelöscht!');
                this.standortSelected = undefined;
                this.standortAutocomplete.clearAndFocus();
            },
            error: error => {
                this.messageService.errorMessage('Der Standort konnte nicht gelöscht werden', error);
            },
        });
    }

    private initGewichtCtrls() {
        this.gesamtgewichtCtrl.valueChanges.subscribe({
            next: gesamtgewicht => {
                if (!isNaN(gesamtgewicht) && this.anzahlTiereAnDatum > 0) {
                    let dg = gesamtgewicht / this.anzahlTiereAnDatum;
                    dg = Math.round(dg * 100) / 100;
                    console.log('dg: ' + dg);
                    this.durchschnittsgewichtCtrl.setValue(dg, { emitEvent: false });
                }
            },
        });
        this.durchschnittsgewichtCtrl.valueChanges.subscribe({
            next: durchschnittsgewicht => {
                if (!isNaN(durchschnittsgewicht) && this.anzahlTiereAnDatum > 0) {
                    const gg = durchschnittsgewicht * this.anzahlTiereAnDatum;
                    console.log('gg: ' + gg);
                    this.gesamtgewichtCtrl.setValue(gg, { emitEvent: false });
                }
            },
        });
    }

    private initDatumCtrl() {
        this.datumVonCtrl.valueChanges.subscribe({
            next: datum => {
                if (this.selectedTiere?.length > 0) {
                    return;
                }
                if (datum) {
                    this.ladeTiereAnDatum(datum);
                }
            },
        });
    }

    private ladeTiereAnDatum(datum: Date) {
        this.gesamtgewichtCtrl.disable();
        this.durchschnittsgewichtCtrl.disable();
        let params = new HttpParams();
        params = params.set('gruppe_id', this.gruppe.gruppe_id);
        params = params.set('datum', formatDate(datum, 'yyyy-MM-dd', this.locale));
        this.api.get(this.apiBaseUrl + 'gruppe/read_anzahl_tiere_an_datum.php', params).subscribe({
            next: response => {
                this.anzahlTiereAnDatum = response.anzahl_tiere;
                this.gesamtgewichtCtrl.setValue(undefined);
                this.durchschnittsgewichtCtrl.setValue(undefined);
                this.gesamtgewichtCtrl.enable();
                this.durchschnittsgewichtCtrl.enable();
            },
            error: err => {
                this.messageService.errorMessage('Fehler', err);
                this.gesamtgewichtCtrl.enable();
                this.durchschnittsgewichtCtrl.enable();
            },
        });
    }

    private saveSelectedTiereGewichte(gsId: number): boolean {
        if (this.isExternerBetriebZiel()) {
            return false;
        }
        if (!this.localStorageService.hasPermission(this.gewichtPermissionId)) {
            return false;
        }
        if (!this.selectedTiere?.length) {
            return false;
        }

        const records = this.buildMostActualAbgangsgewichteRecords();
        if (!records.length) {
            this.closeWithSuccess();
            return true;
        }

        this.api
            .post(this.apiBaseUrl + 'gruppe_standort/save_most_actual_abgangsgewichte.php', {
                gruppe_id: this.gruppe?.gruppe_id,
                records: records,
            })
            .subscribe({
                next: response => {
                    const updatedCount = Number(response?.count_updated || 0);
                    const insertedCount = Number(response?.count_inserted || 0);
                    const countAbgang = updatedCount + insertedCount > 0 ? updatedCount + insertedCount : records.length;
                    this.saveEinstallgewichteAfterAbgang(gsId, records, countAbgang);
                },
                error: err => {
                    this.messageService.errorMessage(
                        'Standort gespeichert, aber Abgangsgewichte konnten nicht vollstaendig gespeichert werden!',
                        err,
                    );
                    this.closeWithSuccess();
                },
            });
        return true;
    }

    private saveEinstallgewichteAfterAbgang(
        gsId: number,
        records: { gt_id: number; most_actual_abgangsgewicht: number; current_gs_id: number | null }[],
        countAbgang: number,
    ): void {
        const einstallenRecords = records.map(r => ({
            gt_id: r.gt_id,
            einstallgewicht: r.most_actual_abgangsgewicht,
        }));
        this.api
            .post(this.apiBaseUrl + 'gruppe_standort/save_einstallgewichte.php', {
                gs_id: gsId,
                gruppe_id: this.gruppe?.gruppe_id,
                records: einstallenRecords,
            })
            .subscribe({
                next: response => {
                    const updatedCount = Number(response?.count_updated || 0);
                    const insertedCount = Number(response?.count_inserted || 0);
                    const countEinstall =
                        updatedCount + insertedCount > 0 ? updatedCount + insertedCount : einstallenRecords.length;
                    this.finishStandortwechselWithWeightMessage(countEinstall, countAbgang);
                },
                error: err => {
                    this.messageService.errorMessage(
                        'Standort gespeichert, aber Einstallengewichte konnten nicht vollstaendig gespeichert werden!',
                        err,
                    );
                    this.closeWithSuccess();
                },
            });
    }

    private finishStandortwechselWithWeightMessage(
        einstallenCount: number,
        countAbgang: number,
    ): void {
        this.messageService.infoMessage(
            `Der Standort wurde erfolgreich gewechselt! Abgangsgewichte fuer ${countAbgang} Tier(e) und Einstallgewichte fuer ${einstallenCount} Tier(e) gespeichert.`,
        );
        this.closeWithSuccess();
    }

    private buildMostActualAbgangsgewichteRecords(): {
        gt_id: number;
        most_actual_abgangsgewicht: number;
        current_gs_id: number | null;
    }[] {
        if (this.isExternerBetriebZiel()) {
            return [];
        }
        if (!this.selectedTiere?.length) {
            return [];
        }
        const allGewicht = this.toValidGewicht(this.gewichtAlleSelektiertCtrl.value);
        return this.selectedTiere
            .map(tier => {
                const ctrlGewicht = this.toValidGewicht(tier.gewichtCtrl.value);
                const gewicht =
                    this.gewichtModusCtrl.value === 'all' && allGewicht !== null ? allGewicht : ctrlGewicht;
                if (gewicht === null) {
                    return null;
                }
                return {
                    gt_id: Number(tier.gt_id),
                    most_actual_abgangsgewicht: gewicht,
                    current_gs_id:
                        Number(tier?.currentGsId) > 0
                            ? Number(tier.currentGsId)
                            : Number(this.currentStandortGsId) > 0
                              ? Number(this.currentStandortGsId)
                              : null,
                };
            })
            .filter(r => !!r && r.gt_id > 0);
    }

    private toValidGewicht(value: any): number | null {
        if (value === null || value === undefined || value === '') {
            return null;
        }
        const parsed = Number(String(value).replace(',', '.'));
        if (isNaN(parsed) || parsed <= 0) {
            return null;
        }
        return Math.round(parsed * 100) / 100;
    }

    get selectedTiereTotalGewicht(): number | null {
        if (!this.selectedTiere?.length) {
            return null;
        }
        const werte = this.selectedTiere
            .map(t => Number(t.gewichtCtrl.value))
            .filter(v => !isNaN(v) && v > 0);
        if (!werte.length) {
            return null;
        }
        return Math.round(werte.reduce((sum, val) => sum + val, 0) * 100) / 100;
    }

    /** Matches backend standort-wechsel filter (not geloescht / tot / ausgestallt / tierliste). */
    static isTierAktivForStandortwechsel(tier: {
        geloescht?: number;
        hit_todesdatum?: string;
        kp_todesdatum?: string;
        todesdatum_notnull?: string;
        hit_abgangsdatum?: string;
        kp_abgangsdatum?: string;
        abgangsdatum_notnull?: string;
        tierliste_id?: number;
    }): boolean {
        if (Number(tier?.geloescht) > 0) {
            return false;
        }
        if (tier?.hit_todesdatum || tier?.kp_todesdatum || tier?.todesdatum_notnull) {
            return false;
        }
        if (tier?.hit_abgangsdatum || tier?.kp_abgangsdatum || tier?.abgangsdatum_notnull) {
            return false;
        }
        if (Number(tier?.tierliste_id) > 0) {
            return false;
        }
        return true;
    }

    private initSelectedTiereGewichte(): void {
        const selectedTiereInput = this.data?.selectedTiere || [];
        this.selectedTiere = selectedTiereInput
            .filter(t => Number(t?.gt_id) > 0 && GruppeStandortWechselnDialogComponent.isTierAktivForStandortwechsel(t))
            .map(t => ({
                gt_id: Number(t.gt_id),
                ohrmarke_notnull: t.ohrmarke_notnull,
                gewichtCtrl: new FormControl(),
                currentGsId: Number(t?.gs_id) > 0 ? Number(t.gs_id) : undefined,
            }));

        this.gewichtAlleSelektiertCtrl.valueChanges.subscribe({
            next: value => {
                if (this.gewichtModusCtrl.value !== 'all') {
                    return;
                }
                for (const tier of this.selectedTiere) {
                    tier.gewichtCtrl.setValue(value, { emitEvent: false });
                }
            },
        });
    }

    private loadSelectedTiereCurrentStandorte(): void {
        if (!this.selectedTiere?.length) {
            return;
        }
        const gtIds = this.selectedTiere.map(t => Number(t.gt_id)).filter(id => id > 0);
        if (!gtIds.length) {
            return;
        }

        const params = new HttpParams().set('gt_ids', gtIds.join(','));
        this.api.getAll(this.apiBaseUrl + 'gruppe/read_gt_letzter_standort.php', params).subscribe({
            next: response => {
                const records = response?.records || [];
                const gsByGtId = new Map<number, number>();
                for (const rec of records) {
                    const gtId = Number(rec?.gt_id);
                    const gsId = Number(rec?.gs_id);
                    if (gtId > 0 && gsId > 0) {
                        gsByGtId.set(gtId, gsId);
                    }
                }
                for (const tier of this.selectedTiere) {
                    const resolvedGsId = gsByGtId.get(Number(tier.gt_id));
                    if (resolvedGsId > 0) {
                        tier.currentGsId = resolvedGsId;
                    }
                }
            },
            error: err => {
                this.messageService.errorMessage('Letzter Standort der Tiere konnte nicht geladen werden!', err);
            },
        });
    }

    private closeWithSuccess(): void {
        const result = new GruppeStandortWechselnDialogResult();
        result.confirm = true;
        this.messageService.infoMessage('Der Standort wurde erfolgreich gewechselt!');
        this.dialogRef.close(result);
    }

    private loadMinDatumVon(): void {
        if (!this.gruppe?.gruppe_id || this.gruppeStandort?.gs_id) {
            return;
        }
        let params = new HttpParams().set('gruppe_id', this.gruppe.gruppe_id?.toString());
        params = params.set('orderby', 'datum_von');
        this.api.getAll(this.apiBaseUrl + 'gruppe_standort/read.php', params).subscribe({
            next: response => {
                const records = response?.records || [];
                let latestDate: Date = null;
                for (const rec of records) {
                    const raw = rec?.datum_von || rec?.datum_bis;
                    if (!raw) {
                        continue;
                    }
                    const d = new Date(raw);
                    if (isNaN(d.getTime())) {
                        continue;
                    }
                    if (!latestDate || d.getTime() > latestDate.getTime()) {
                        latestDate = d;
                    }
                }
                if (!latestDate) {
                    return;
                }
                latestDate.setHours(0, 0, 0, 0);
                const min = new Date(latestDate);
                min.setDate(min.getDate() + 1);
                this.minDatumVon = min;
                const currentValue = this.datumVonCtrl.value ? new Date(this.datumVonCtrl.value) : null;
                if (currentValue && !isNaN(currentValue.getTime()) && currentValue.getTime() < min.getTime()) {
                    this.datumVonCtrl.setValue(min);
                }
            },
            error: () => {
                // If min date cannot be loaded, user can continue and backend validation still applies.
            },
        });
    }

    private isDatumVonValidForNewStandort(): boolean {
        if (!this.minDatumVon || this.gruppeStandort?.gs_id) {
            return true;
        }
        if (!this.datumVonCtrl.value) {
            return false;
        }
        const selected = new Date(this.datumVonCtrl.value);
        if (isNaN(selected.getTime())) {
            return false;
        }
        selected.setHours(0, 0, 0, 0);
        const min = new Date(this.minDatumVon);
        min.setHours(0, 0, 0, 0);
        return selected.getTime() >= min.getTime();
    }

    private isStandortInputValid(): boolean {
        return !!this.standortSelected && String(this.standortSelected).trim().length > 0;
    }

    private isExternerBetriebZiel(): boolean {
        const gruppeKundeId = Number(this.gruppe?.kunde_id);
        if (gruppeKundeId <= 0) {
            return true;
        }
        return !this.gewichtErlaubteKundeIds.has(gruppeKundeId);
    }

    private loadGewichtErlaubteBetriebe(): void {
        forkJoin({
            meine: this.api.getAll(this.apiBaseUrl + 'kunde/read_kundenportal_meine.php'),
            freigaben: this.api.getAll(this.apiBaseUrl + 'kunde/read_kundenportal_freigaben.php'),
        }).subscribe({
            next: ({ meine, freigaben }) => {
                const ids = [...(meine?.records || []), ...(freigaben?.records || [])]
                    .map(v => Number(v?.kunde_id))
                    .filter(v => v > 0);
                this.gewichtErlaubteKundeIds = new Set(ids);
            },
            error: () => {
                this.gewichtErlaubteKundeIds = new Set<number>();
            },
        });
    }
}
